import { JsonSchemaValidator } from "@common/json-schema-validator";
import { NoticeData, NoticeKind } from "../interface";
import { noticeData, noticeKind } from "../schema";

export class NoticeCreate1Cmd {
  private static configValidation = JsonSchemaValidator.compile(
    NoticeCreate1Cmd.configValidationSchema()
  );

  readonly value: NoticeCreate1;

  constructor(value: NoticeCreate1) {
    this.value = JsonSchemaValidator.assert(
      NoticeCreate1Cmd.configValidation,
      value
    );
  }

  private static configValidationSchema() {
    return {
      type: "object",
      required: ["kind", "data"],
      properties: {
        kind: noticeKind,
        data: noticeData
      },
      additionalProperties: false
    };
  }
}

interface NoticeCreate1 {
  kind: NoticeKind;
  data: NoticeData;
}
